import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Form, Input, Select } from 'antd';

import { useAppSelector } from 'app/store';
import { useChangeConsultantMutation } from 'app/services/edpApiV1/consultations';
import { ViewerSubordinatesResponse } from 'app/services/edpApiV1/viewer';

import { viewerModel } from 'entities/viewer';

import { usePath } from 'shared/hooks';
import { useNotifications } from 'shared/hooks/use-notifications';
import { TSingleConsultationPreparedData } from 'shared/types/consultations.types';

import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import { RolesUser } from 'shared/enums';
import style from './index.module.scss';

const ConsultationFormUserMain = ({
  allSubordinates,
  dataConsultations,
}: {
  allSubordinates: ViewerSubordinatesResponse;
  dataConsultations: TSingleConsultationPreparedData[];
}) => {
  const [btnHrVisible, setBtnHrVisible] = useState<boolean>(false);

  const { id } = useParams();
  const [form] = Form.useForm();
  const path = usePath(2);
  const consultationHr = dataConsultations[0]?.consultant;
  const feedback = dataConsultations[0]?.feedback;
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const [changeConsultant, resultChangeConsultant] = useChangeConsultantMutation();

  const {
    isSuccess: successChangeConsultant,
    isError: isErrorChangeConsultant,
    data: messageChangeConsultant,
    reset: resetChangeConsultant,
  } = resultChangeConsultant;

  const onChangeConsultant = (values: { consultantId: number }) => {
    const { consultantId } = values;
    const bodyRequest = {
      chatId: Number(id),
      consultantId,
    };
    changeConsultant(bodyRequest);
    setBtnHrVisible(false);
  };

  const selectHandler = (consultantId: number) => {
    if (consultantId === consultationHr.id) {
      setBtnHrVisible(false);
    } else {
      setBtnHrVisible(true);
    }
  };

  useEffect(() => {
    if (dataConsultations && allSubordinates && dataConsultations?.length > 0) {
      form.setFields([
        {
          name: 'tabel',
          value: dataConsultations[0]?.personnelNumber,
        },
        {
          name: 'consultantId',
          value: `${consultationHr.lastName || ''} ${consultationHr.name || ''} ${consultationHr.middleName || ''}`,
        },
      ]);

      if (dataConsultations[0]?.isClaim) {
        form.setFields([
          {
            name: 'isClaim',
            value: dataConsultations[0]?.isClaim,
          },
        ]);
      }

      if (dataConsultations[0]?.isJustified) {
        form.setFields([
          {
            name: 'isJustified',
            value: dataConsultations[0]?.isJustified,
          },
        ]);
      }
    }
  }, [dataConsultations, allSubordinates, form]);

  useNotifications(
    successChangeConsultant,
    isErrorChangeConsultant,
    'Ответственный изменён',
    messageChangeConsultant?.data,
    resetChangeConsultant,
  );

  return (
    <Form form={form} layout="vertical" onFinish={onChangeConsultant} name="userInfo" className={style.userInfo}>
      <div className={style.groupItem}>
        <Form.Item name="tabel" label="Табельный номер" labelAlign="left" className={style.inputWrap}>
          <Input className="userInput" disabled />
        </Form.Item>
        {allSubordinates && (
          <Form.Item
            name="consultantId"
            label="Ответственный HR"
            labelAlign="left"
            className={style.inputWrap}
            rules={[
              {
                validator: async (_, v) => {
                  if (v === consultationHr.id) return Promise.reject();
                },
                message: 'Выберите нового ответственного',
              },
            ]}
          >
            <Select
              placeholder="Выберите из списка"
              onSelect={selectHandler}
              disabled={path === 'archive' || (role !== RolesUser.HRDirector && role !== RolesUser.SecondLine)}
            >
              {allSubordinates?.map(({ id, name, middleName, lastName }) => (
                <Select.Option key={id} value={id}>
                  {`${lastName} ${name} ${middleName ?? ''}`}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )}
      </div>
      {!allAvailableOrganizations && btnHrVisible && (
        <Form.Item labelAlign="left" className={style.btn}>
          <Button htmlType="submit" type="primary">
            Сохранить
          </Button>
        </Form.Item>
      )}
    </Form>
  );
};

export default ConsultationFormUserMain;
